// extracted by mini-css-extract-plugin
export default {"inputEditable":"EditableSpanTitle_inputEditable__ItkrM","spanEditable":"EditableSpanTitle_spanEditable__IZUHY"};